export default __webpack_public_path__ + "static/media/our_planet_tiger.5e7b8203.mp4";